import { render, staticRenderFns } from "./detailsRewardProgram.vue?vue&type=template&id=b2e9ec98&scoped=true&"
import script from "./detailsRewardProgram.vue?vue&type=script&lang=js&"
export * from "./detailsRewardProgram.vue?vue&type=script&lang=js&"
import style0 from "./detailsRewardProgram.vue?vue&type=style&index=0&id=b2e9ec98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e9ec98",
  null
  
)

component.options.__file = "detailsRewardProgram.vue"
export default component.exports